export const AUTH_ROUTE = '/auth';
export const REGISTRATION_ROUTE = '/auth/registration';
export const RECOVERY_ROUTE = '/auth/recovery';